module.exports = __webpack_public_path__ + "static/media/paulina.9c1b1147.jpg";